module.exports = __webpack_public_path__ + "bin/e98ce6da7c57771b8563a85ed57adc17.png";